module.exports = __webpack_public_path__ + "static/media/block.4c2e4fbf.svg";